// extracted by mini-css-extract-plugin
export default {"title":"MyTrainingClassesSection-module__title"};